import PubSub from "underpub-js";

let DirectoryWidget = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};


DirectoryWidget.prototype.init = function () {

	var self = this;

	// Activating the widget after a certain scroll distance is reached
	PubSub.subscribe("scroll", function(options){

		// show the popup once the user has scrolled past 35% of the page
		if(options.scrollTopPct > 0.14999999){
			self.options.$el.addClass("is-active");
		}

	});

};

export default  DirectoryWidget;
